<template>
    <v-container>
        <v-layout justify-center>
            <v-flex xs12 md8 lg6>
                <Barcode :backgroundColor="backgroundColor" :title="type" subtitle="Scan or Enter a Serial Number"
                    buttonText="Transition" @search="transitionProduct" ref="barcodeComponent" />
                <v-card :color="backgroundColor">
                    <v-select :items="allPrinters" v-model="selectedPrinter" color="secondary"
                        label="Select Printer" box :style="{ width: '50%', margin: 'auto', marginTop: '-30px' }"></v-select>
                        <v-checkbox class="pt-4" v-model="autoprint" color="secondary" label="Autoprint Labels"
                        :style="{ width: '50%', margin: 'auto' }"></v-checkbox>
                </v-card>
            </v-flex>

            <!-- <v-flex xs6 class="mx-4">
                <v-card :color="backgroundColor"
                    :style="{ width: '100%', margin: 'auto', height: '650px', overflow: 'auto' }">

                    <v-select class="pt-4" :items="allPrinters" v-model="selectedPrinter" color="secondary"
                        label="Select Printer" box :style="{ width: '50%', margin: 'auto' }"></v-select>
                    <v-checkbox class="pt-4" v-model="autoprint" color="secondary" label="Autoprint Labels"
                        :style="{ width: '50%', margin: 'auto' }"></v-checkbox>
                    <v-data-table lat :headers="headers" class="mx-2" :items="scannedProducts"
                        :total-items="scannedProducts.length" :pagination.sync="pagination">
                        <template v-slot:items="props">
                            <td class="text-xs-left">{{ props.item.lot }}</td>
                            <td class="text-xs-left">
                                {{ props.item.previous }}
                            </td>
                            <td class="text-xs-left">
                                {{ props.item.current }}
                            </td>
                            <td>
                                <v-btn color="secondary" @click="transitionProduct(props.item.lot)">
                                    Re-Print
                                </v-btn>
                            </td>
                        </template>
                    </v-data-table>

                </v-card>
            </v-flex> -->
        </v-layout>

    </v-container>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import LoginCheck from "@/mixins/LoginCheck";
import Barcode from "@/components/app/Barcode";

export default {
    name: "sku-check",
    data() {
        return {

            backgroundColor: "primary",
            type: this.$route.params.type || "SKU Check",
            headers: [
                { text: "Lot/Serial", value: "lot" },
                { text: "Previous SKU", value: "previous" },
                { text: "Current SKU", value: "current" },
                { text: "Actions", value: "actions", sortable: false }
            ],
            scannedProducts: [],
        };
    },

    components: {
        Barcode
    },

    mixins: [LoginCheck],

    computed: {
        ...mapGetters({
            storedPrinter: "repair/getSelectedPrinter",
            storedAutoprint: "repair/getAutoPrint",
            allPrinters: "repair/getAllPrinters",
            user: "app/getUser",
        }),

        selectedPrinter: {
            get() {
                return this.storedPrinter;
            },
            set(val) {
                return this.$store.commit("repair/setSelectedPrinter", val);
            },
        },

        autoprint: {
            get() {
                return this.storedAutoprint;
            },
            set(val) {
                return this.$store.commit("repair/setAutoprint", val);
            },
        }

    },

    mounted() {
        this.$refs.barcodeComponent.focusBarcode();
    },
    async beforeMount() {

        await this.getAllPrinters();
    },

    methods: {
        ...mapActions({
            transitionRepair: "repair/transitionRepair",
            printAsurionLabel: "repair/printAsurionLabel",
            printVZDLabel: "repair/printVZDLabel",
            printCTDILabel: "repair/printCTDILabel",
            getAllPrinters: "repair/getAllPrinters",
            getAsurionPO: "repair/getAsurionPO",
            printProductLabel: "repair/printProductLabel",
        }),

        handleCleared() {
            this.$refs.barcodeComponent.focusBarcode();
        },
        async transitionProduct(barcodeValue) {
            if (this.autoprint && !this.selectedPrinter) {
                this.$store.dispatch("app/setSnackbar", {
                    text: "Please select a printer before scanning.",
                    color: "red",
                });
                return;
            }

            const res = await this.transitionRepair({
                name: barcodeValue,
                type: this.type,
            });
            if (res.success) {
                if (this.type == 'asurion' && this.autoprint) {
                    // let po = await this.getAsurionPO({sku: res.new_product.sku});
                    // if (!po.success) {
                    //     this.$store.dispatch("app/setSnackbar", {
                    //         text: po.message,
                    //         color: "red",
                    //     });
                    //     return;
                    // }
                    // await this.printAsurionLabel({
                    //     printer: this.selectedPrinter,
                    //     imei: res.imei,
                    //     sku: res.new_product.sku,
                    //     po: po.po
                    // })

                    await this.printProductLabel({
                        printer: this.selectedPrinter,
                        sn: res.repair_name,
                        sku: res.new_product.sku,
                        barcode: res.new_product.barcode,
                        description: res.new_product.desc,
                        owner: 'VZS',
                        size: 'small'
                    });
                } else if (this.type == 'vzd' && this.autoprint) {
                    this.printVZDLabel({
                        printer: this.selectedPrinter,
                        sku: res.new_product.sku,
                        serial: res.repair_name,
                        barcode: res.new_product.barcode,
                        desc: res.new_product.desc,
                    })
                }
                else if (this.type == 'ctdi' && this.autoprint) {
                    await this.printCTDILabel({
                        printer: this.selectedPrinter,
                        sku: res.new_product.sku,
                        serial: res.imei,
                        model: res.model,
                    });
                }
                this.scannedProducts.unshift({
                    lot: res.repair_name,
                    previous: res.previous_product.sku,
                    current: res.new_product.sku,
                    dateCreated: new Date().toISOString(),
                });
                this.handleCleared();
            } else {
                this.$store.dispatch("app/setSnackbar", {
                    text: res.message,
                    color: "red",
                });
            }
        },
    }
};
</script>

<style></style>